export default {
  isLoading: true,
  language: null,
  languages: [],
}
